var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLayoutSort = function SvgIcLayoutSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#DDE4FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic-layout-sort_svg__a)",
    fill: "#6472B7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.283 5.91h-6.86C4.191 5.91 4 5.705 4 5.455S4.186 5 4.423 5h6.86c.232 0 .423.205.423.455s-.187.455-.423.455ZM9.2 8.453H4.422c-.232 0-.423-.205-.423-.455s.186-.455.423-.455H9.2c.232 0 .423.205.423.455s-.186.455-.423.455ZM11.283 11h-6.86C4.191 11 4 10.795 4 10.545s.186-.455.423-.455h6.86c.232 0 .423.205.423.455s-.187.455-.423.455Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic-layout-sort_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 5)",
    d: "M0 0h7.706v6H0z"
  })))));
};
export default SvgIcLayoutSort;